import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import AboutUs from './pages/AboutUs';
import Contacts from './pages/Contacts';
import Cart from './pages/Cart';
import FullCart from './pages/FullCart';
import './scss/main.scss';
import OrderForm from './pages/Orederform';
import OrderSuccess from './pages/OrederSuccess';
import Delivery from './pages/ Delivery';
import Footer from './components/Footer';
import Modal from './components/Modal';
import Cookie from './pages/Cookie';



function App() {

  return (
    <div className="app-container">
        <Nav />
        <Modal />
        <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/order" element={<OrderForm />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/description/:id" element={<FullCart />} />
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/order-success/:orderNumber" element={<OrderSuccess />} /> */}
          <Route path="/order-success" element={<OrderSuccess />} />
        </Routes>
        </main>
        <Footer />

    </div>
  );
}

export default App;
